export const UserTypes ={
    Client: 'Client',
    admin: 'Admin',
    superAdmin: 'Super_Admin',
    internal:'Internal',
    external:'External'
};